import React, { useState } from 'react';

const Star = ({ filled, half }) => (
  <span className="relative inline-block leading-none" aria-hidden="true">
    <span className={filled ? 'text-black' : 'text-gray-300'}>★</span>
    {half && (
      <span className="absolute inset-0 overflow-hidden text-black" style={{ width: '50%' }}>
        ★
      </span>
    )}
  </span>
);

/**
 * Read-only star display. `value` may be fractional (e.g. 4.35).
 */
export const StarDisplay = ({ value = 0, size = 'text-sm', className = '' }) => {
  const rating = Number(value) || 0;

  return (
    <span className={`inline-flex gap-0.5 ${size} ${className}`} role="img"
          aria-label={`${rating.toFixed(1)} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          filled={rating >= star}
          half={rating < star && rating > star - 1}
        />
      ))}
    </span>
  );
};

/**
 * Interactive star input.
 */
export const StarInput = ({ value = 0, onChange, size = 'text-3xl' }) => {
  const [hovered, setHovered] = useState(0);
  const active = hovered || value;

  return (
    <div className={`inline-flex gap-1 ${size}`} onMouseLeave={() => setHovered(0)}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange(star)}
          onMouseEnter={() => setHovered(star)}
          aria-label={`${star} star${star > 1 ? 's' : ''}`}
          className={`leading-none transition-colors ${
            active >= star ? 'text-black' : 'text-gray-300 hover:text-gray-400'
          }`}
        >
          ★
        </button>
      ))}
    </div>
  );
};

export default StarDisplay;
